import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert
} from '@mui/material';
import Key from '../../clientVariables.json';

const ResetPassword = () => {
  const { emailToken } = useParams();
  const navigate = useNavigate();
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }
    
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
  
    try {
      setLoading(true);
      const [email, token] = emailToken.split('_');
      
      const response = await axios.put(`${Key.domain}/common/update_password`, {
        email: email,
        token: token,
        password: password
      });
  
      if (response.data.success === 1) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setError(response.data.error || "Password reset failed");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
    
//     if (password !== confirmPassword) {
//       setError("Passwords don't match");
//       return;
//     }
    
//     if (password.length < 8) {
//       setError("Password must be at least 8 characters long");
//       return;
//     }
  
//     try {
//       setLoading(true);
//       const [email, token] = emailToken.split('_');
      
//       const response = await axios.put(`http://localhost:7758/common/update_password`, {
//         email: email,
//         token: token,
//         password: password
//       });
  
//       if (response.data.success === 1) {
//         setSuccess(true);
//         setTimeout(() => navigate('/login'), 3000);
//       } else {
//         setError(response.data.data || "Failed to reset password");
//       }
//     } catch (err) {
//       setError(err.response?.data?.data || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
    
//     // Validation checks
//     if (password !== confirmPassword) {
//       setError("Passwords don't match");
//       return;
//     }
    
//     if (password.length < 8) {
//       setError("Password must be at least 8 characters long");
//       return;
//     }

//     try {
//       setLoading(true);
//       const [email, token] = emailToken.split('_'); // Split email and token
      
//       const response = await axios.put(`${Key.domain}/common/update_password`, {
//         username: email,
//         currentPassword: token, // Using token as currentPassword
//         password: password
//       });

//       if (response.status === 200 && response.success == 1) {
//         setSuccess(true);
//         setTimeout(() => {
//           navigate('/login');
//         }, 3000);
//       } else {
//         setError(response.data?.message || "Failed to reset password");
//       }
//     } catch (err) {
//       // Handle different error responses
//       if (err.response) {
//         if (err.response.status === 400) {
//           setError(err.response.data?.data || "Bad request - invalid input");
//         } else if (err.response.status === 500) {
//           setError("Internal server error. Please try again later.");
//         } else {
//           setError(err.response.data?.error || "Something went wrong");
//         }
//       } else {
//         setError("Network error. Please check your connection.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Reset Your Password
        </Typography>
        
        {success ? (
          <Box sx={{ mt: 3 }}>
            <Alert severity="success">
              Password updated successfully! Redirecting to login...
            </Alert>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            
            <Typography variant="body1" sx={{ mb: 2 }}>
              Please enter your new password below.
            </Typography>
            
            <TextField
              fullWidth
              margin="normal"
              label="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              inputProps={{ minLength: 8 }}
            />
            
            <TextField
              fullWidth
              margin="normal"
              label="Confirm New Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              inputProps={{ minLength: 8 }}
            />
            
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                size="large"
                sx={{ minWidth: 150 }}
              >
                {loading ? 'Updating...' : 'Update Password'}
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ResetPassword;

// import React, { useState } from 'react';
// import axios from 'axios';
// import { useParams, useNavigate } from 'react-router-dom';
// import { 
//   Container,
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Paper,
//   Alert
// } from '@mui/material';
// import Key from '../../clientVariables.json'; 

// const ResetPassword = () => {
//   const { emailToken } = useParams(); 
//   const navigate = useNavigate();
  
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
    
//     if (password !== confirmPassword) {
//       setError("Passwords don't match");
//       return;
//     }
    
//     if (password.length < 8) {
//       setError("Password must be at least 8 characters long");
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.put(`${Key.domain}/common/update_password`, {
//         username: emailToken.split('_')[0], // Extract email from token
//         currentPassword: emailToken.split('_')[1], // Extract token
//         password: password
//       });

//       if (response.data.success === 1) {
//         setSuccess(true);
//         // Redirect to login after 3 seconds
//         setTimeout(() => {
//           navigate('/login');
//         }, 3000);
//       } else {
//         setError(response.data.data || "Failed to reset password");
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || "Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="sm" sx={{ mt: 8 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Typography variant="h4" component="h1" gutterBottom align="center">
//           Reset Your Password
//         </Typography>
        
//         {success ? (
//           <Box sx={{ mt: 3 }}>
//             <Alert severity="success">
//               Password updated successfully! You'll be redirected to login page shortly.
//             </Alert>
//           </Box>
//         ) : (
//           <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
//             {error && (
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {error}
//               </Alert>
//             )}
            
//             <TextField
//               fullWidth
//               margin="normal"
//               label="New Password"
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
            
//             <TextField
//               fullWidth
//               margin="normal"
//               label="Confirm New Password"
//               type="password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               required
//             />
            
//             <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 disabled={loading}
//                 size="large"
//               >
//                 {loading ? 'Resetting...' : 'Reset Password'}
//               </Button>
//             </Box>
//           </Box>
//         )}
//       </Paper>
      
//       <Box sx={{ mt: 3, textAlign: 'center' }}>
//         <Typography variant="body2" color="textSecondary">
//           Remember your password? <a href="/login" style={{ textDecoration: 'none' }}>Login</a>
//         </Typography>
//       </Box>
//     </Container>
//   );
// };

// export default ResetPassword;